import { useInAppBrowser } from 'App/capacitor';
import { TIENDA_NUBE_THEMES_LINKS } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';

export function useInstallDraft(themeCode: string, themeVariant?: string) {
  const language = useTranslationLanguage();
  const openInAppBrowser = useInAppBrowser();

  const installThemeInStoreUrl = `${
    TIENDA_NUBE_THEMES_LINKS[language]
  }/instalar/${themeCode}${themeVariant ? '/' + themeVariant : ''}`;

  const handleInstallDraft = async () => {
    await openInAppBrowser(installThemeInStoreUrl);
  };

  return handleInstallDraft;
}
